<template>
<div class="sidebar main-sidebar">
	<h1>Explore Logistics</h1>
	<grid flat class="tabs-caption">
		<grid-item size="1/2">
			<h3 class="pos-left" :class="activeTab == 0 ? 'active' : ''" @click="activeTab = 0">Opportunities</h3>
		</grid-item>
		<grid-item size="1/2">
			<h3 class="pos-right" :class="activeTab == 1 ? 'active' : ''" @click="activeTab = 1">Companies</h3>
		</grid-item>
	</grid>
	<grid flat class="tabs-content" v-if="activeTab == 0">
		<grid-item size="1/1">
			<custom-multiple-select
				label="By Air"
				:itemList="airportList"
				itemValue="id"
				v-model="selectedAir"
			/>
			<custom-multiple-select
				label="By Sea"
				:itemList="portList"
				itemValue="id"
				v-model="selectedSea"
			/>
			<hr>
			<button class="button primary" @click="search()">View on map</button>
		</grid-item>
	</grid>
	<grid class="tabs-content" v-if="activeTab == 1">
		<grid-item size="1/1">
			<custom-multiple-select
				label="By Air"
				:itemList="airportList"
				itemValue="id"
				v-model="selectedAir"
			/>
			<custom-multiple-select
				label="By Sea"
				:itemList="portList"
				itemValue="id"
				v-model="selectedSea"
			/>
			<hr>
			<button class="button primary" @click="search()">View on map</button>
		</grid-item>
	</grid>
</div>
</template>

<script>
import CustomMultipleSelect from '@/components/secondary/CustomMultipleSelect'

export default {
	components: {
		CustomMultipleSelect
	},
	data: () => ({
		activeTab: 0,
		selectedAir: [],
		selectedSea: [],
		airportList: [
			{ name: 'Airport 1' },
			{ name: 'Airport 2' },
			{ name: 'Airport 3' }
		],
		portList: [
			{ name: 'Port 1' },
			{ name: 'Port 2' },
			{ name: 'Port 3' }
		]
	}),
	methods: {
		search() {
			this.$router.push({
				name: 'opportunity-list'
			})
		}
	}
}
</script>

<style lang="scss">
</style>
